export const SUCCESS_LIBRARY_SEARCH = "SUCCESS_LIBRARY_TOPIC";
export const LOADING_LIBRARY_TOPIC_SEARCH = "LOADING_LIBRARY_TOPIC_SEARCH";

export const SearchTypes = {
  SUCCESS_LIBRARY_SEARCH,
  LOADING_LIBRARY_TOPIC_SEARCH
};
